import { ulid } from 'ulid';
import { EventDispatcher } from 'ste-events';
import Cookies from 'js-cookie';
var PROPS_COOKIE_PREFIX = '_sl_props';
var ID_COOKIE_PREFIX = '_sl_id';
var SessionManager = /** @class */ (function () {
    function SessionManager(envId, user) {
        this.envId = envId;
        // We need to use SameSite=None for iframe support
        this.cookieApi = Cookies.withAttributes({ sameSite: 'None', secure: true });
        this._onChanged = new EventDispatcher();
        this.setUser(user);
        this.setSessionProperties({
            envId: this.envId,
            projId: '',
            orgId: ''
        });
    }
    SessionManager.prototype.setSessionProperties = function (sessionProperties) {
        this.cookieApi.set("".concat(PROPS_COOKIE_PREFIX, ".").concat(this.envId), JSON.stringify(sessionProperties));
        this._onChanged.dispatch(this, {
            property: 'properties',
            value: sessionProperties
        });
    };
    SessionManager.prototype.setSessionIdentity = function (sessionIdentity) {
        this.cookieApi.set("".concat(ID_COOKIE_PREFIX, ".").concat(this.envId), JSON.stringify(sessionIdentity));
        this._onChanged.dispatch(this, {
            property: 'identity',
            value: sessionIdentity
        });
    };
    SessionManager.prototype.setUser = function (user) {
        if (user === void 0) { user = { key: ulid() }; }
        if (user.key === undefined) {
            user.key = ulid();
        }
        this.cookieApi.set("".concat(ID_COOKIE_PREFIX, ".").concat(this.envId), JSON.stringify(user));
    };
    SessionManager.prototype.getUser = function () {
        var cookieUserString = this.cookieApi.get("".concat(ID_COOKIE_PREFIX, ".").concat(this.envId));
        return cookieUserString ? JSON.parse(cookieUserString) : null;
    };
    SessionManager.prototype.getBase64User = function () {
        var cookieUserString = this.cookieApi.get("".concat(ID_COOKIE_PREFIX, ".").concat(this.envId));
        return cookieUserString ? btoa(cookieUserString) : '';
    };
    /**
     * Get the session identity from the cookie. If it does not exist, one will be created.
     */
    SessionManager.prototype.getSessionIdentity = function () {
        var identity = this.getIdentity();
        if (identity === null) {
            throw new Error('Session identity not found');
        }
        return identity;
    };
    SessionManager.prototype.getIdentity = function () {
        var sessionIdentityString = this.cookieApi.get("".concat(ID_COOKIE_PREFIX, ".").concat(this.envId));
        return sessionIdentityString ? JSON.parse(sessionIdentityString) : null;
    };
    SessionManager.prototype.resetSessionIdentity = function () {
        this.setSessionIdentity({
            sessionId: ulid(),
            userId: ulid()
        });
    };
    Object.defineProperty(SessionManager.prototype, "onChanged", {
        get: function () {
            return this._onChanged.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    return SessionManager;
}());
export { SessionManager };
//# sourceMappingURL=SessionManager.js.map